import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { RoundContext } from 'components/Rounds/__Rounds.context'

const Round: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.RoundParams>()

  return (
    <RoundContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </RoundContext.Provider>
  )
}

export default Round
